import { render, staticRenderFns } from "./OwnerCompo.vue?vue&type=template&id=c9b7d3c6&"
import script from "./OwnerCompo.vue?vue&type=script&lang=js&"
export * from "./OwnerCompo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports